import React, { useEffect, useState } from "react";
import { Box, useMediaQuery, useTheme } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { motion } from "framer-motion";
import ProfileHeader from "../../components/profile/ProfileHeader";
import ProfileCard from "../../components/profile/ProfileCard";
import ProfileTabs from "../../components/profile/ProfileTabs";
import Loader from "../../components/loader/Loader";
import { API_CALL_STATUS } from "../../assets/constants/constants";
import { getUserDetails, getUserAddressObject } from "../../redux/user/userSlice";
import ProfileHeaderShimmer from "../../components/profile/ProfileHeader/ProfileHeaderShimmer";
import ProfileCardShimmer from "../../components/profile/ProfileCard/ProfileCardShimmer";
import ProfileTabsShimmer from "../../components/profile/ProfileTabs/ProfileTabsShimmer";
import { useNotification } from "../../components/shared/NotificationProvider";

const ProfilePage = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const dispatch = useDispatch();
  const notify = useNotification();

  const [tabIndex, setTabIndex] = useState(0);

  const apiCallStatus = useSelector((state) => state.user.status);
  const userInfo = useSelector((state) => state.user.userInfo);
  const profileObj = useSelector((state) => state.user.profilePic);
  const userAddressDetails = useSelector((state) => state.user.userAddressDetails);
  const homeImages = useSelector((state) => state.user.homeImages);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        if (Object.keys(userInfo).length === 0) {
          await dispatch(getUserDetails());
        }
        if (Object.keys(userAddressDetails).length === 0 || homeImages.length === 0) {
          await dispatch(getUserAddressObject());
        }
      } catch {
        notify.error("Failed to load profile data");
      }
    };
    fetchUserData();
  }, [dispatch]);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <Box
        sx={{
          maxWidth: "100%",
          mx: "auto",
          p: { xs: 2, md: 4 },
          backgroundColor: "#fff",
          minHeight: "100vh"
        }}
      >
        {apiCallStatus === API_CALL_STATUS.LOADING ? (
          <ProfileHeaderShimmer />
        ) : (
          <ProfileHeader userInfo={userInfo} />
        )}

        <Box
          sx={{
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            gap: 4,
            mt: 4
          }}
        >
          {apiCallStatus === API_CALL_STATUS.LOADING ? (
            <ProfileCardShimmer />
          ) : (
            <ProfileCard
              profileObj={profileObj}
              userInfo={userInfo}
            />
          )}

          <Box sx={{ flex: 1 }}>
            {apiCallStatus === API_CALL_STATUS.LOADING ? (
              <ProfileTabsShimmer />
            ) : (
              <ProfileTabs
                tabIndex={tabIndex}
                setTabIndex={setTabIndex}
                userInfo={userInfo}
              />
            )}
          </Box>
        </Box>
      </Box>
    </motion.div>
  );
};

export default ProfilePage;
